var _path, _rect, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShiftStarted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09553 2.83567C1.07439 7.86635 4.64975 16.4987 11.7579 16.5059C18.8655 16.4991 22.4413 7.86691 17.4202 2.83579C14.4396 -0.271015 9.07622 -0.270514 6.09553 2.83567ZM14.6714 10.5268L12.6948 8.55027C12.7122 8.25836 12.5877 7.97937 12.3831 7.79832C12.3833 7.79178 12.3835 7.78521 12.3835 7.77861V4.1188C12.3504 3.28874 11.165 3.28937 11.1322 4.1188V7.77861C11.1322 7.78521 11.1324 7.79178 11.1326 7.79832C10.4783 8.38395 10.9221 9.48077 11.8101 9.43504L13.7866 11.4116C14.0309 11.6559 14.427 11.6559 14.6713 11.4116C14.9157 11.1673 14.9157 10.7712 14.6714 10.5268Z",
    fill: "#222222"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 23.4941,
    width: 1.5,
    height: 6,
    rx: 0.75,
    transform: "rotate(-180 5.25 23.4941)",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 19.7441C17.9142 19.7441 18.25 20.0799 18.25 20.4941C18.25 20.9084 17.9142 21.2441 17.5 21.2441L7 21.2441C6.58579 21.2441 6.25 20.9084 6.25 20.4941C6.25 20.0799 6.58579 19.7441 7 19.7441L17.5 19.7441Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 22.4941L19.25 20.4941L17.25 18.4941",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftStarted);
export default __webpack_public_path__ + "static/media/shiftStarted.9bd8ddd1.svg";
export { ForwardRef as ReactComponent };